import { render, staticRenderFns } from "./CellTransactionState.vue?vue&type=template&id=1fdefb4c"
import script from "./CellTransactionState.vue?vue&type=script&lang=js"
export * from "./CellTransactionState.vue?vue&type=script&lang=js"
import style0 from "./CellTransactionState.vue?vue&type=style&index=0&id=1fdefb4c&prod&lang=scss&scpoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports